



























import { computed, defineComponent, ref, toRef, watch } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import ChoosePostType from "@/components/ChoosePostType";

export default defineComponent({
  name: "ChoosePostTypeController",
  components: { BaseConfirm, BaseButton, ChoosePostType },
  props: {
    showChooseType: { type: Boolean, required: true },
    postType: { type: String as () => ContentFeedTypeEnum | null },
    userId: { type: String, required: true },
    onlyLivesAllowed: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const draft = ref<ContentSet | null>(null);

    const draftId = computed(() => draft.value?.id ?? "");

    const checkHasDraft = async () => {
      loading.value = true;
      const contentSetSearchResult = await providers.ContentSetProvider.search({
        data: { userId: props.userId, published: false, ...(props.postType ? { types: [props.postType] } : {}) },
      });
      draft.value = contentSetSearchResult.result.find(i => !i.published) ?? null;
      if (!draft.value) {
        emit("createPost", props.postType, () => {
          loading.value = false;
        });
      }
    };

    const onUseDraft = () => {
      emit("setPostData", draft.value, () => {
        loading.value = false;
      });
      draft.value = null;
    };

    const onDeleteDraft = async () => {
      try {
        if (!draftId.value) {
          return;
        }
        await providers.ContentSetProvider.delete({ id: draftId.value });
        draft.value = null;
      } finally {
        if (props.postType) {
          emit("createPost", props.postType, () => {
            loading.value = false;
          });
        }
      }
    };

    const watchPostTypeHandler = async () => {
      if (props.postType && !props.onlyLivesAllowed) {
        await checkHasDraft();
      }
    };

    watch(toRef(props, "postType"), watchPostTypeHandler, { immediate: true });

    return { draftId, loading, onUseDraft, onDeleteDraft };
  },
});
